import { UserModel } from '$store/models';
import { ContentPriorityType } from '$store/main/interface';

export const setSubscriptionAuthor = (author: UserModel) => {
  try {
    localStorage.setItem('subscriptionAuthorId', author.id.toString());
    localStorage.setItem(
      'subscriptionContentPriority',
      author.verified === 2 ? ContentPriorityType.ADULT : ContentPriorityType.OTHER,
    );
  } catch (e) {}
};

export const setSubscriptionContentPriority = (contentPriority: ContentPriorityType) => {
  try {
    localStorage.setItem('subscriptionContentPriority', contentPriority);
  } catch (e) {}
};

export const getSubscriptionAuthor = (): {
  authorId: UserModel['id'];
  contentPriority: ContentPriorityType;
} => {
  try {
    return {
      authorId: parseInt(localStorage.getItem('subscriptionAuthorId') || '0'),
      contentPriority:
        (localStorage.getItem('subscriptionContentPriority') as ContentPriorityType) ||
        ContentPriorityType.NONE,
    };
  } catch (e) {
    return {
      authorId: 0,
      contentPriority: ContentPriorityType.NONE,
    };
  }
};
